import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '../AuthContext';

export default function PhoneCapture({ onDone, onCancel }) {
  const { savePhone } = useAuth();
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');

  const handleSave = () => {
    const digits = phone.replace(/\D/g, '');
    if (digits.length < 8) { setError('Please enter a valid phone number'); return; }
    savePhone(phone.trim());
    onDone();
  };

  return (
    <div style={s.overlay} onClick={onCancel}>
      <motion.div
        initial={{ y: '100%' }} animate={{ y: 0 }} exit={{ y: '100%' }}
        transition={{ type: 'spring', damping: 28, stiffness: 320 }}
        style={s.sheet} onClick={(e) => e.stopPropagation()}
      >
        <div style={s.handle} />
        <h2 style={s.title}>Your phone number</h2>
        <p style={s.sub}>Required to confirm your order.</p>

        <div style={s.field}>
          <label style={s.label}>PHONE NUMBER</label>
          <input
            style={s.input}
            placeholder="+61 400 000 000"
            type="tel"
            value={phone}
            onChange={(e) => { setPhone(e.target.value); setError(''); }}
            autoFocus
          />
        </div>

        {error && <p style={s.error}>{error}</p>}

        <motion.button whileTap={{ scale: 0.98 }} style={s.saveBtn} onClick={handleSave}>
          Continue →
        </motion.button>
      </motion.div>
    </div>
  );
}

const s = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.82)', zIndex: 400, display: 'flex', alignItems: 'flex-end' },
  sheet: { background: '#141416', borderRadius: '28px 28px 0 0', padding: '14px 24px 40px', width: '100%', maxWidth: '430px', margin: '0 auto', fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif' },
  handle: { width: '38px', height: '4px', background: '#333', borderRadius: '2px', margin: '0 auto 24px' },
  title: { fontSize: '24px', fontWeight: '700', color: '#fff', margin: '0 0 6px' },
  sub: { fontSize: '14px', color: '#666', margin: '0 0 24px', lineHeight: '1.5' },
  field: { display: 'flex', flexDirection: 'column', gap: '7px', marginBottom: '8px' },
  label: { fontSize: '10px', letterSpacing: '2px', color: '#555', fontWeight: '600' },
  input: { background: '#0d0d0f', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '13px', padding: '14px 16px', color: '#fff', fontSize: '16px', fontFamily: 'inherit', outline: 'none', width: '100%', boxSizing: 'border-box' },
  error: { fontSize: '13px', color: '#ff6b6b', margin: '0 0 12px' },
  saveBtn: { width: '100%', background: '#FFFFFF', color: '#0a0a0a', border: 'none', borderRadius: '15px', padding: '16px', fontSize: '16px', fontWeight: '700', fontFamily: 'inherit', cursor: 'pointer', marginTop: '16px' },
};
